import React, { useRef, useState, useContext } from "react";
import PexelsVideos from "./PexelsVideos";
import swal from "sweetalert";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
import UploadedVideo from "./UploadedVideo";
import { ProgressBar } from "react-bootstrap";
import { useEffect } from "react";
import TickerContext from "../../../../context/ticker";
import GreenScreenModel from "./GreenScreenModel";

export const VideosWrapper = (props) => {
  const { Goto, TickerPosition } = useContext(TickerContext);
  const [UploadedData, setUploadedData] = useState([]);
  const { authenticationData } = useContext(AuthContext);
  const [UploadedGSData, setUploadedGSData] = useState([]);
  const [GSProgress, setGSProgress] = useState(0);
  const [GS_file, setGS_file] = useState("");
  const [TabState, setTabState] = useState("Free");
  const VideoUploderRef = useRef(null);
  const VideoGSUploderRef = useRef(null);
  const UploadData = useRef(null);
  const [showGreenScreenModel, setShowGreenScreenModel] = useState(false);

  const { GS_Data, setGS_Data } = useContext(MyContext);

  useEffect(() => {
    if (Goto.innerMenu != null) {
      if (Goto.innerMenu === "vid") {
        setTabState("Free");
      }
    }
  }, [Goto]);

  const VideoUpload = (e) => {
    VideoUploderRef.current.click();
  };

  const GreenScreen = (e) => {
    VideoGSUploderRef.current.click();
  };

  const [file, setFile] = useState(0);

  const handlefile = (e) => {
    var video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      var duration = video.duration;
      //console.log("gettingDuration");
      if (duration <= 60) {
        setFile(0);
        greenScreenFileUploads(e.target.files[0]);
      } else {
        swal("Failed", "Video length is more then 1 minute", "error");
      }
    };
    video.src = URL.createObjectURL(e.target.files[0]);
  };

  const [progress, setprogress] = useState(0);

  const fileChangeHandle = (e) => {
    const file = e.target.files[0];
  
    // Check file size
    const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
    if (fileSizeInMB > 200) {
      swal("Failed", "File size exceeds the limit of 200MB", "error");
      return;
    }
    var video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      var duration = video.duration;
      //console.log("gettingDuration");
      if (duration <= 300) {
        setprogress(0);
        upload(e.target.files[0]);
      } else {
        swal("Failed", "Video length is more than 5 minutes", "error");
      }
    };
    video.onerror = function () {
      swal("Failed", "This video file cannot be read. Please use an MP4 or WebM video.", "error");
    };
    video.src = URL.createObjectURL(e.target.files[0]);
    //console.log("video src = " + video.src);
  };

  //Upload Green Screen Video

  const greenScreenFileUploads = (e) => {
    var fileInputEl = e.target.files;
    var formData = new FormData();
    setShowGreenScreenModel(true);
    formData.append("file", fileInputEl[0]);
    let gsAuth = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));

    // Sent through the API, which holds the green-screen service key (before: the key was here).
    axios
      .post(`${authenticationData.ApiBaseURL}/api/Export/GSUpload`, formData, {
        headers: { Authorization: "Bearer " + gsAuth.access_token },
      })
      .then((res) => {
        if (!res.data || !res.data.success) {
          setShowGreenScreenModel(false);
          swal("Failed", "The green screen service could not take this video. Please try another video.", "error");
          return;
        }

        setGS_file(res.data.filename);
      })
      .catch(function (reason) {
        // Before: a browser alert("ERROR: Network Error") and the settings dialog kept spinning.
        console.log("Green screen upload failed.", reason);
        setGSProgress(0);
        setShowGreenScreenModel(false);
        swal("Failed", "The green screen service is not reachable right now. Please try again later.", "error");
      });
  };

  async function ProcessVideo(filename, similarity, blend, shapeColor) {
    var formdata = new FormData();
    formdata.append("fileName", filename);
    formdata.append("similarity", similarity);
    formdata.append("blend", blend);
    formdata.append("color", shapeColor);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .post(
        `${authenticationData.ApiBaseURL}/api/Export/GetGSTaskId`,
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        const task_id = JSON.parse(response.data.response).task_id;

        CheckingPercentage(task_id);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // Progress of the green screen job. Asked every 2 seconds (before: again immediately after each
  // answer, hundreds of requests a minute) and given up after 15 minutes or 5 failed requests in a
  // row (before: a failed request stopped it silently and the progress bar stayed).
  const gsPoll = useRef({ started: 0, failures: 0 });
  const CheckingPercentage = (task_id) => {
    if (!gsPoll.current.started || gsPoll.current.task_id !== task_id) gsPoll.current = { started: Date.now(), failures: 0, task_id };
    if (Date.now() - gsPoll.current.started > 15 * 60 * 1000) {
      setGSProgress(0);
      swal("Failed", "Removing the green screen took too long. Please try again.", "error");
      return;
    }
    axios
      .get(`${authenticationData.ApiBaseURL}/api/Export/GSProgress?taskId=${encodeURIComponent(task_id)}`, {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("animation_studio_2.0_access_token")).access_token,
        },
      })
      .then((response) => {
        if (response.data.result !== 100) {
          setGS_Data({
            stage: "CheckingPercentage",
            task_id: task_id,
            UploadedGSData: UploadedGSData,
          });
          setGSProgress(response.data.result);
          gsPoll.current.failures = 0;
          setTimeout(() => CheckingPercentage(task_id), 2000);
        } else {
          setGS_Data({
            stage: "CheckingPercentage",
            task_id: task_id,
            UploadedGSData: UploadedGSData,
            filename: response.data.filename,
          });
          setGSProgress(100);
          //storeVideoUrl(`https://videobiz.io/bgremove_app/static/output/${response.data.filename}`)
        }
      })
      .catch((err) => {
        console.log(err);
        gsPoll.current.failures++;
        if (gsPoll.current.failures < 5) {
          setTimeout(() => CheckingPercentage(task_id), 3000);
        } else {
          setGSProgress(0);
          swal("Failed", "The green screen service is not reachable right now. Please try again later.", "error");
        }
      });
  };

  useEffect(() => {
    if (GSProgress === 100) {
      if (GS_Data) {
        uploadGSVideo(
          `https://videobiz.io/bgremove_app/static/output/${GS_Data.filename}`
        );
        setGS_Data(null);
        setGSProgress(0);
      }
    }
  }, [GSProgress]);

  // upload Green Screen video
  const uploadGSVideo = (url) => {
    var formdata = new FormData();
    formdata.append("url", url);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Images/uploadGSVideo",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let prcnt = Math.floor((loaded * 100) / total);
            setGSProgress(prcnt);
          },
        }
      )
      .then((response) => {
        if (response.data) {
          setTimeout(() => {
            setGSProgress(0);
          }, 200);
          let urls = [];
          response.data.map((val, index) => {
            urls.push({
              id: val.id,
              VideoUrl: val.path,
              previewImgUrl: val.previewImagePath,
            });
          });
          setUploadedGSData(urls.concat(UploadedGSData));
          swal("Excellent", "Video Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Video. Please Try Again", "error");
          setGSProgress(0);
        }
        // UploadData.current.value = "";
      })
      .catch((e) => {
        console.log(e);
        setGSProgress(0);
        swal("Failed", "Unable to Upload Video. Please Try Again", "error");
      });
  };

  const upload = (data) => {
    var formdata = new FormData();
    formdata.append("file", data);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Images/UploadVideo",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            let prcnt = Math.floor((loaded * 100) / total);
            setprogress(prcnt);
          },
        }
      )
      .then((response) => {
        if (response.data) {
          setTimeout(() => {
            setprogress(0);
          }, 200);
          let urls = [];
          response.data.map((val, index) => {
            urls.push({
              id: val.id,
              VideoUrl: authenticationData.ApiBaseURL + val.path,
              previewImgUrl:
                authenticationData.ApiBaseURL + val.previewImagePath,
            });
          });
          setUploadedData(urls.concat(UploadedData));
          swal("Excellent", "Video Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Video. Please Try Again", "error");
          setprogress(0);
        }
        // UploadData.current.value = "";
      })
      .catch((e) => {
        console.log(e);
        setprogress(0);
        if (e && e.response && e.response.status === 415) {
          swal("Failed", "Please upload an MP4, WebM or MOV video.", "error");
          return;
        }
        swal("Failed", "Unable to Upload Video. Please Try Again", "error");
      });
  };

  const onInputClick = (event) => {
    event.target.value = "";
  };
  useEffect(() => {
    if (TabState === "greenScreen") {
      if (GS_Data) {
        if (GS_Data.stage === "CheckingPercentage") {
          setGSProgress(GS_Data.UploadedGSData);
          CheckingPercentage(GS_Data.task_id);
        }
      }
    }
  }, [TabState]);

  return (
    <div id="videosWrapper" className="innerWrapperPanel">
      <div className="templatesWrapper">
        <div className="divLabel mb-3">Videos</div>

        <div className="tabs mb-2">
          <div className="p2">
            <div
              className={"tabButton" + (TabState == "Free" ? " activeTab" : "")}
              onClick={() => setTabState("Free")}
            >
              Free Stock
            </div>
            <div
              className={
                "tabButton" + (TabState == "greenScreen" ? " activeTab" : "")
              }
              onClick={() => setTabState("greenScreen")}
            >
              Green Screen
            </div>
            <div
              className={
                "tabButton" + (TabState == "Uploads" ? " activeTab" : "")
              }
              onClick={() => setTabState("Uploads")}
            >
              Uploads
            </div>
          </div>
        </div>

        {TabState == "Free" && <PexelsVideos />}

        {TabState == "greenScreen" && (
          <>
            <div
              style={{
                height: "100%",
                width: "100%",
                padding: "0px 12px",
              }}
            >
              {/* <div
                className="Image_uploader_text"
                onClick={() => GreenScreen()}
              >
                <div> Upload Video</div>
                <div className="Image_uploader_text">
                  <input
                    type="file"
                    onChange={(event) => greenScreenFileUploads(event)}
                    accept="video/*"
                  ></input>
                </div>
              </div> */}
              <div
                onClick={() => GreenScreen()}
                className="image_uploader_inner"
              >
                <div className="image_uploader_icon_container">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 486.3 486.3"
                  >
                    <g>
                      <g>
                        <path
                          fill="#286aff"
                          d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5
			                                    c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16
			                                    C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86
			                                    c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69
                                                c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9
                                                c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6
                                                c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6
                                                c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"
                        />
                        <path
                          fill="#286aff"
                          d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1
                                                c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5
                                                C310.4,285.3,318.9,285.3,324.2,280z"
                        />
                      </g>
                    </g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                  </svg>
                </div>
                <div className="Image_uploader_text">
                  <div>Upload Video</div>
                  <input
                    ref={VideoGSUploderRef}
                    type="file"
                    hidden
                    onChange={(event) => greenScreenFileUploads(event)}
                    accept="video/*"
                  ></input>
                </div>
              </div>
              {GSProgress > 0 && (
                <ProgressBar now={GSProgress} label={`${GSProgress}%`} />
              )}
              <UploadedVideo
                UploadedData={UploadedGSData}
                setUploadedData={setUploadedGSData}
                TaBName={"UploadGreenScreen"}
              />
            </div>

            <GreenScreenModel
              show={showGreenScreenModel}
              onHide={setShowGreenScreenModel}
              filename={GS_file}
              setfilename={setGS_file}
              ApiBaseURL={authenticationData.ApiBaseURL}
              ProcessVideo={ProcessVideo}
            />
          </>
        )}

        {TabState == "Uploads" && (
          <>
            <div
              style={{
                height: "100%",
                width: "100%",
                padding: "0px 12px",
              }}
            >
              <div
                onClick={() => VideoUpload()}
                className="image_uploader_inner"
              >
                <div className="image_uploader_icon_container">
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 486.3 486.3"
                  >
                    <g>
                      <g>
                        <path
                          fill="#286aff"
                          d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5
			                                    c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16
			                                    C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86
			                                    c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69
                                                c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9
                                                c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6
                                                c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6
                                                c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"
                        />
                        <path
                          fill="#286aff"
                          d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1
                                                c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5
                                                C310.4,285.3,318.9,285.3,324.2,280z"
                        />
                      </g>
                    </g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                  </svg>
                </div>
                <div className="Image_uploader_text">
                  <div>Upload Video</div>
                  <input
                    onClick={onInputClick}
                    ref={VideoUploderRef}
                    type="file"
                    hidden
                    onChange={(event) => fileChangeHandle(event)}
                    accept="video/*"
                  ></input>
                </div>
              </div>
              {progress > 0 && (
                <ProgressBar
                  className="mt-2 mb-2"
                  now={progress}
                  label={`${progress}%`}
                />
              )}
              <UploadedVideo
                UploadedData={UploadedData}
                setUploadedData={setUploadedData}
                TaBName={"Upload"}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default VideosWrapper;
